<template>
  <v-app>
    <!-- Top Menu Bar -->
    <v-app-bar
      flat
      app
      :color="barBg"
      height="60"
      :style="{ 'margin-left': $vuetify.breakpoint.mdAndDown ? '0' : '8px' }"
    >
      <!-- icon for mobile nav drawer -->
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown" @click.stop="isDrawerOpen = !isDrawerOpen">
        <v-icon :color="barTheme" class="fi fi-rr-arrow-alt-square-right" style="font-size: 22px"></v-icon>
      </v-app-bar-nav-icon>

      <!-- Left logo -->
      <div v-if="logo_img">
        <v-img :src="`${$mediaPath}${logo_img}`" :max-height="60" :max-width="200" contain position="left"></v-img>
      </div>

      <v-spacer />

      <!-- for desktop app bar -->
      <v-menu
        flat
        bottom
        offset-y
        nudge-bottom="10"
        rounded="lg"
        content-class="elevation-0 elevation-custom"
        transition="slide-y-transition"
        v-model="isUserMenuOpen"
        :close-on-content-click="!disableCloseMenu"
      >
        <!-- User Display Button -->
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" depressed text :class="`user-menu-open-button ${barTheme}--text`">
            <span>{{ userName }}{{ $validate.DataValid(centerName) ? ' | ' : '' }}{{ centerName }}</span>
            <v-icon class="ml-8">
              {{ isUserMenuOpen ? icon.mdiChevronUp : icon.mdiChevronDown }}
            </v-icon>
          </v-btn>
        </template>

        <v-list class="px-2" dense nav>
          <!-- 切換分店 -->
          <NavListItem
            v-if="userType !== 'student'"
            class="user-menu-item logout-btn"
            icon="fi fi-rr-replace"
            @btnClick="centerSelectDialogOpen = true"
            :name="$t('switchCampus')"
          />

          <!-- 語言 -->
          <NavListItem
            class="user-menu-item logout-btn"
            icon="fi fi-rr-language"
            @btnClick="openLangSelector()"
            :name="$t('language')"
          />

          <!-- 登出 -->
          <NavListItem
            class="user-menu-item logout-btn"
            icon="fi fi-rr-sign-in-alt"
            @btnClick="logoutAndCloseMenu()"
            :name="$t('logout')"
          />
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- Sidebar -->
    <NavDrawer :drawerItemList="drawerItems" :isDrawerOpen.sync="isDrawerOpen"></NavDrawer>

    <!-- Modal: 切換分店 -->
    <DialogLayout
      v-if="userType !== 'student'"
      :openDialog="centerSelectDialogOpen"
      title="selectCampus"
      btnAlign="center"
      eager
      @close="updateSelectedCenter($event)"
    >
      <v-radio-group v-model="tempSelectedCenterId">
        <v-radio
          v-for="item in centerOptions"
          :key="item.value"
          :label="item.text"
          :value="item.value"
          hide-details
        ></v-radio>
      </v-radio-group>
    </DialogLayout>

    <!-- Modal: 語言 -->
    <DialogLayout
      :openDialog="languageSelectDialogOpen"
      title="chooseLanguage"
      btnAlign="center"
      eager
      @close="updateSelectedLang($event)"
    >
      <v-radio-group v-model="selectedLang">
        <v-radio
          v-for="item in langOptions"
          :key="item.value"
          :label="item.text"
          :value="item.value"
          hide-details
        ></v-radio>
      </v-radio-group>
    </DialogLayout>

    <!-- Main Content -->
    <v-main>
      <div :class="mainContentClass">
        <v-fade-transition mode="out-in">
          <div>
            <template>
              <slot> </slot>
            </template>
          </div>
        </v-fade-transition>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mdiChevronUp, mdiChevronDown } from '@mdi/js'

import NavListItem from '@/components/NavDrawer/NavListItem.vue'
import NavDrawer from '@/components/NavDrawer/NavDrawer.vue'
import DialogLayout from '@/components/layout/DialogLayout.vue'
import { serverTimeFunc } from '@/utils/serverTime'

export default {
  components: {
    NavListItem,
    NavDrawer,
    DialogLayout,
  },
  data: () => ({
    icon: {
      mdiChevronUp,
      mdiChevronDown,
    },
    isDrawerOpen: false,
    isUserMenuOpen: false,
    disableCloseMenu: false,

    drawerItems: [],

    userId: null,
    userName: '',
    userType: '',

    centerOptions: [],
    centerName: '',
    tempSelectedCenterId: null,
    userCenterIds: [],
    centerSelectDialogOpen: false,

    languageSelectDialogOpen: false,
    selectedLang: 'zh',
    langOptions: [
      { value: 'zh', text: '繁體中文' },
      { value: 'en', text: 'English' },
    ],

    barBg: '#ffffff',
    barTheme: 'dark',
    logo_img: '',

    serverTimeInterval: null,
  }),
  computed: {
    mainContentClass() {
      const fullPages = ['OrderList']
      return {
        'fullW-container pt-5 pb-2 px-2': true
        // 'fullW-container pt-5 pb-2 px-2': fullPages.includes(this.$route.name),
        // 'fullW-container pt-5 pb-2 px-2': !fullPages.includes(this.$route.name),
        // 'app-content-container boxed-container py-6 px-3 px-sm-6 px-md-6 px-lg-6 px-xl-6': !fullPages.includes(
        //   this.$route.name,
        // ),
      }
    },
    getFullPath() {
      return this.$route.path
    },
  },
  watch: {
    getFullPath() {
      this.getCenterData()
    },
  },
  methods: {
    initDrawerItems() {
      const menus = [
        {
          isGroup: false,
          id: 'dashboard',
          text: this.$t('menu.dashboard'),
          linkName: 'Dashboard',
          icon: 'fi fi-rr-dashboard',
          show: this.$validate.allowAction('Dashboard', this.userType),
          subPages: ['Dashboard'],
        },
        {
          isGroup: false,
          id: 'pay-tuition',
          text: this.$t('menu.payTuition'),
          linkName: 'PayTuitionList',
          icon: 'fi fi-rr-piggy-bank',
          show: this.$validate.allowAction('PayTuitionList', this.userType),
          subPages: ['PayTuitionPayment'],
        },
        {
          isGroup: false,
          id: 'timetable',
          text: this.$t('menu.timetable'),
          linkName: 'Timetable',
          icon: 'fi fi-rr-calendar',
          show: this.$validate.allowAction('Timetable', this.userType),
          subPages: ['CreateAppointment', 'AppointmentDetails'],
        },
        {
          isGroup: false,
          id: 'customer',
          text: this.$t('menu.customer'),
          linkName: 'CustomerList',
          icon: 'fi fi-rr-grin',
          show: this.$validate.allowAction('CustomerList', this.userType),
          subPages: ['CustomerDetails', 'CreateCustomer', 'CustomerAttendance'],
        },
        {
          isGroup: false,
          id: 'customer-user',
          text: this.$t('menu.customerInfo'),
          linkName: 'CustomerUserDetails',
          icon: 'fi fi-rr-grin',
          show: this.$validate.allowAction('CustomerUserDetails', this.userType),
          subPages: [],
        },
        {
          isGroup: false,
          id: 'customer-user-attendance',
          text: this.$t('attendanceRecord'),
          linkName: 'CustomerUserAttendance',
          icon: 'fi fi-rr-memo',
          show: this.$validate.allowAction('CustomerUserAttendance', this.userType),
          subPages: [],
        },
        {
          isGroup: false,
          id: 'customer-user-order',
          text: this.$t('menu.order'),
          linkName: 'CustomerUserOrderList',
          icon: 'fi fi-rr-donate',
          show: this.$validate.allowAction('CustomerUserOrderList', this.userType),
          subPages: [],
        },
        {
          isGroup: true,
          id: 'service',
          text: this.$t('menu.service'),
          icon: 'fi fi-rr-room-service',
          show:
            this.$validate.allowAction('ServiceList', this.userType) ||
            this.$validate.allowAction('ServiceCategoryList', this.userType),
          items: [
            {
              show: this.$validate.allowAction('ServiceList', this.userType),
              text: this.$t('menu.allServices'),
              linkName: 'ServiceList',
              subPages: ['ServiceDetails', 'CreateService'],
            },
            {
              show: this.$validate.allowAction('GeneralServiceCategoryList', this.userType),
              text: this.$t('menu.generalServiceCategory'),
              linkName: 'GeneralServiceCategoryList',
              subPages: ['GeneralServiceCategoryDetails', 'CreateGeneralServiceCategory'],
            },
            {
              show: this.$validate.allowAction('ServiceCategoryList', this.userType),
              text: this.$t('menu.serviceCategory'),
              linkName: 'ServiceCategoryList',
              subPages: ['ServiceCategoryDetails', 'CreateServiceCategory'],
            },
          ],
        },
        {
          isGroup: false,
          id: 'order',
          text: this.$t('menu.order'),
          linkName: 'OrderList',
          icon: 'fi fi-rr-donate',
          show: this.$validate.allowAction('OrderList', this.userType),
        },
        {
          isGroup: false,
          id: 'month-order',
          text: this.$t('menu.month'),
          linkName: 'MonthOrderList',
          icon: 'fi fi-rr-donate',
          show: this.$validate.allowAction('MonthOrderList', this.userType),
        },
        {
          isGroup: true,
          id: 'product',
          text: this.$t('menu.product'),
          icon: 'fi fi-rr-cube',
          show:
            this.$validate.allowAction('ProductList', this.userType) ||
            this.$validate.allowAction('ProductCategoryList', this.userType),
          items: [
            {
              show: this.$validate.allowAction('ProductList', this.userType),
              text: this.$t('menu.allProducts'),
              linkName: 'ProductList',
              subPages: ['ProductDetails', 'CreateProduct'],
            },
            {
              show: this.$validate.allowAction('ProductCategoryList', this.userType),
              text: this.$t('menu.productCategory'),
              linkName: 'ProductCategoryList',
              subPages: ['ProductCategoryDetails', 'CreateProductCategory'],
            },
          ],
        },
        {
          isGroup: true,
          id: 'package',
          text: this.$t('menu.package'),
          icon: 'fi fi-rr-ticket',
          show:
            this.$validate.allowAction('PackageList', this.userType) ||
            this.$validate.allowAction('PackageCategoryList', this.userType),
          items: [
            {
              show: this.$validate.allowAction('PackageList', this.userType),
              text: this.$t('menu.allPackages'),
              linkName: 'PackageList',
              subPages: ['PackageDetails', 'CreatePackage'],
            },
            {
              show: this.$validate.allowAction('PackageCategoryList', this.userType),
              text: this.$t('menu.packageCategory'),
              linkName: 'PackageCategoryList',
              subPages: ['PackageCategoryDetails', 'CreatePackageCategory'],
            },
          ],
        },
        {
          isGroup: false,
          id: 'center',
          text: this.$t('menu.campus'),
          linkName: 'CenterList',
          icon: 'fi fi-rr-book-open-cover',
          show: this.$validate.allowAction('CenterList', this.userType),
          subPages: ['CenterDetails', 'CreateCenter'],
        },
        {
          isGroup: false,
          id: 'room',
          text: this.$t('menu.room'),
          linkName: 'RoomList',
          icon: 'fi fi-rr-door-open',
          show: this.$validate.allowAction('RoomList', this.userType),
          subPages: ['RoomDetails', 'CreateRoom'],
        },
        {
          isGroup: false,
          id: 'staff',
          text: this.$t('menu.staff'),
          linkName: 'StaffList',
          icon: 'fi fi-rr-chalkboard-user',
          show: this.$validate.allowAction('StaffList', this.userType),
          subPages: ['StaffDetails', 'CreateStaff'],
        },
        {
          isGroup: false,
          id: 'agreement',
          text: this.$t('menu.agreement'),
          linkName: 'AgreementList',
          icon: 'fi fi-rr-document-signed',
          show: this.$validate.allowAction('AgreementList', this.userType),
          subPages: ['CreateAgreement', 'AgreementDetails'],
        },
        {
          isGroup: true,
          id: 'shift',
          text: this.$t('menu.shift'),
          icon: 'fi fi-rr-replace',
          show:
            this.$validate.allowAction('ShiftCode', this.userType) ||
            this.$validate.allowAction('ShiftControl', this.userType) ||
            this.$validate.allowAction('ShiftStaffCount', this.userType) ||
            this.$validate.allowAction('ShiftHourCount', this.userType) ||
            this.$validate.allowAction('DailyShiftHour', this.userType),
          items: [
            {
              show: this.$validate.allowAction('ShiftCode', this.userType),
              text: this.$t('shiftCode'),
              linkName: 'ShiftCode',
              subPages: ['ShiftCodeDetails', 'CreateShiftCode'],
            },
            {
              show: this.$validate.allowAction('ShiftControl', this.userType),
              text: this.$t('shiftControl'),
              linkName: 'ShiftControl',
            },
            {
              show: this.$validate.allowAction('ShiftStaffCount', this.userType),
              text: this.$t('shiftStaffCount'),
              linkName: 'ShiftStaffCount',
            },
            {
              show: this.$validate.allowAction('ShiftHourCount', this.userType),
              text: this.$t('shiftHourCount'),
              linkName: 'ShiftHourCount',
            },
            {
              show: this.$validate.allowAction('DailyShiftHour', this.userType),
              text: this.$t('dailyShiftHour'),
              linkName: 'DailyShiftHour',
            },
          ],
        },
        {
          isGroup: false,
          id: 'setting',
          text: this.$t('menu.setting'),
          linkName: 'Setting',
          icon: 'fi fi-rr-settings',
          show: this.$validate.allowAction('Setting', this.userType),
        },
        {
          isGroup: false,
          id: 'report',
          text: this.$t('menu.report'),
          linkName: 'Report',
          icon: 'fi fi-rr-chart-histogram',
          show: this.$validate.allowAction('Report', this.userType),
        },
      ]

      this.drawerItems = menus
      if (this.$validate.DataValid(this.$excludeMenuList) && this.$excludeMenuList.length > 0) {
        this.drawerItems = menus.filter(el => !this.$excludeMenuList.includes(el.id))
        for (let i = this.drawerItems.length - 1; i >= 0; i--) {
          if (this.$validate.DataValid(this.drawerItems[i].items) && this.drawerItems[i].items.length > 0) {
            this.drawerItems[i].items = this.drawerItems[i].items.filter(el => {
              if (this.$validate.DataValid(el.id)) {
                return !this.$excludeMenuList.includes(el.id)
              }

              return true
            })
          }

          if (
            this.drawerItems[i].isGroup &&
            (!this.$validate.DataValid(this.drawerItems[i].items) || this.drawerItems[i].items.length < 1)
          ) {
            this.drawerItems.splice(i, 1)
          }
        }
      }
    },

    async getSetting() {
      try {
        const data = await this.$Fetcher.GetSetting()
        if (data['logo']) {
          this.logo_img = data['logo']
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    // =========== 切換分店 ===========
    async getCenterData() {
      try {
        const { data } = await this.$Fetcher.GetCenters()
        const filtered = data.filter(el => el.active === true)
        if (this.$validate.DataValid(filtered)) {
          this.centerOptions = filtered.map(el => {
            return {
              value: el.id,
              text: el.name,
              logo: el.logo
            }
          })

          await this.getUserCentersList()
        }
      } catch (err) {
        this.$common.error(err)
        this.dispatchSiteLoaded()
      }
    },
    async getUserCentersList() {
      this.tempSelectedCenterId = null
      if (this.$validate.DataValid(this.userId)) {
        try {
          if (this.userType === 'student') {
            await this.$Fetcher.GetCustomerById(this.userId)
          } else {
            const data = await this.$Fetcher.GetStaffById(this.userId)

            const allCenterIds = this.centerOptions.map(el => el.value)
            let userCenterIds = []
            let userSelectedCenterId = null
            if (data.user_type === 'developer') {
              userCenterIds = allCenterIds
            } else if (this.$validate.DataValid(data.centers)) {
              userCenterIds = this.$common.duplicateData(data.centers)
              userCenterIds = userCenterIds.filter(el => allCenterIds.includes(el))
            }

            const selectedCenterId = this.getUserSelectedCenter()
            if (
              this.$validate.DataValid(selectedCenterId) &&
              selectedCenterId > -1 &&
              userCenterIds.includes(selectedCenterId)
            ) {
              userSelectedCenterId = selectedCenterId
            } else {
              userSelectedCenterId = userCenterIds[0]
            }

            await this.updateUserCenters(userCenterIds)
            await this.updateUserSelectedCenter(userSelectedCenterId)

            this.centerOptions = this.centerOptions.filter(el => userCenterIds.includes(el.value))
            this.tempSelectedCenterId = userSelectedCenterId
            this.centerName = ''
            const target = this.centerOptions.find(item => item.value === userSelectedCenterId)
            if (target) this.centerName = target.text
            console.log("target", target)
            if (target && target.logo){
              this.logo_img = target.logo
            }else{
              this.getSetting()
            }
          }
        } catch (err) {
          this.$common.error(err)
          this.logoutAndCloseMenu()
        } finally {
          this.dispatchSiteLoaded()
        }
      }
    },
    async updateSelectedCenter(action) {
      if (action === true) {
        const updated = await this.updateUserSelectedCenter(this.tempSelectedCenterId)
        if (updated) {
          let nextName = ''
          for (let i = 0; i < this.drawerItems.length; i++) {
            if (this.drawerItems[i].isGroup && this.$validate.DataValid(this.drawerItems[i].items)) {
              for (let j = 0; j < this.drawerItems[i].items.length; j++) {
                if (
                  this.drawerItems[i].items[j].subPages &&
                  this.drawerItems[i].items[j].subPages.includes(this.$route.name)
                ) {
                  nextName = this.drawerItems[i].items[j].linkName
                  break
                }
              }
            } else if (this.drawerItems[i].subPages && this.drawerItems[i].subPages.includes(this.$route.name)) {
              nextName = this.drawerItems[i].linkName
            }

            if (nextName !== '') {
              break
            }
          }

          if (nextName !== '' && this.$route.name !== nextName) {
            this.$router.push({ name: nextName })
          } else {
            const currentQuery = { ...this.$route.query }
            if (currentQuery['center']) delete currentQuery['center']
            this.$router.replace({ query: currentQuery })
            this.$router.go()
          }

          this.centerSelectDialogOpen = false
        } else {
          this.$store.dispatch('toggleSnack', {
            message: 'message.updateFail',
            type: 'error',
          })
        }
      } else {
        const selectedCenterId = this.getUserSelectedCenter()
        this.tempSelectedCenterId = this.$common.duplicateData(selectedCenterId)
        this.centerSelectDialogOpen = false
      }
    },

    // =========== 語言 ===========
    openLangSelector() {
      this.selectedLang = this.$i18n.locale
      this.languageSelectDialogOpen = true
    },
    updateSelectedLang(action) {
      if (action === true) {
        localStorage.setItem(process.env.VUE_APP_LANG_STORE_NAME, this.selectedLang)
        this.$i18n.locale = this.selectedLang
        window.scrollTo(0, 0)
        this.$router.go()
      }
      this.languageSelectDialogOpen = false
    },

    // =========== 登出 ===========
    logoutAndCloseMenu() {
      this.disableCloseMenu = false
      this.logout()
    },

    dispatchSiteLoaded() {
      const loaded = new Event('onSiteLoaded')
      window.dispatchEvent(loaded)

      // this.getSetting()
    },
  },
  async mounted() {
    const userData = await this.getCurrentUserData()
    if (this.$validate.DataValid(userData)) {
      this.userName = userData.username
      this.userId = userData.id
      this.getCenterData()
    }

    if (!this.$validate.DataValid(this.serverTimeInterval)) {
      this.serverTimeInterval = setInterval(() => {
        serverTimeFunc.fetchServerTime()
      }, 1000 * 60 * 5)

      serverTimeFunc.fetchServerTime()
    }
  },
  async created() {
    this.barBg = process.env.VUE_APP_BAR_BACKGROUND_COLOR || '#ffffff'
    this.barTheme = process.env.VUE_APP_BAR_COLOR_THEME || 'dark'
    const lang = localStorage.getItem(process.env.VUE_APP_LANG_STORE_NAME)
    if (lang) {
      this.selectedLang = lang
    }

    const check = await this.checkUserData()
    if (check) {
      this.userType = await this.getUserType()
      this.initDrawerItems()
    }
  },
  beforeDestroy() {
    if (this.$validate.DataValid(this.serverTimeInterval)) {
      clearInterval(this.serverTimeInterval)
      this.serverTimeInterval = null
    }
  },
}
</script>

<style lang="scss" scoped>
.boxed-container {
  max-width: 1450px;
  margin-left: auto;
  margin-right: auto;
}

.fullW-container {
  max-width: calc(100% - 60px);
  margin-left: auto;
  margin-right: auto;
}

@media #{map-get($display-breakpoints, 'md-and-down')} {
  .fullW-container {
    max-width: calc(100% - 20px);
  }
}
</style>
